import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'fuToClass'
})
export class FileUploadToClassPipe implements PipeTransform {
	transform(value: any, args?: any): any {
		return value.split(' ').join('_').toLowerCase();
	}
}
